<template>
  <main class="legal">
    <img
      class="legal__stars"
      src="/assets/pictos/decor-legal.png"
      alt=""
      aria-hidden="true"
    >

    <div class="container legal__inner">
      <p class="section-kicker">{{ page.kicker }}</p>
      <h1 class="section-title legal__title">{{ page.title }}</h1>
      <p class="legal__updated">{{ page.updated }}</p>

      <p
        v-if="page.intro"
        class="legal__intro"
      >{{ page.intro }}</p>

      <section
        v-for="section in page.sections"
        :key="section.title"
        class="legal__section"
      >
        <h2>{{ section.title }}</h2>
        <template
          v-for="(block, i) in blocks(section.body)"
          :key="i"
        >
          <ul v-if="block.list">
            <li
              v-for="(item, j) in block.lines"
              :key="j"
            >{{ item }}</li>
          </ul>
          <p v-else>{{ block.text }}</p>
        </template>
      </section>

      <div class="legal__back">
        <router-link
          class="btn-pill is-red-outline"
          to="/"
        >
          <BtnStar />
          {{ page.backLabel }}
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
import BtnStar from '@/components/BtnStar.vue'

export default {
  name: 'LegalView',
  components: { BtnStar },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    // la même vue sert les deux pages, choisie par la route
    page() {
      return this.data[this.$route.meta.page] || this.data.legal
    }
  },
  methods: {
    // une ligne = un paragraphe ; les lignes consécutives en « - » forment une liste
    blocks(body) {
      const out = []
      for (const raw of (body || '').split('\n')) {
        const line = raw.trim()
        if (!line) continue
        if (line.startsWith('- ')) {
          const last = out[out.length - 1]
          if (last && last.list) last.lines.push(line.slice(2))
          else out.push({ list: true, lines: [line.slice(2)] })
        } else {
          out.push({ list: false, text: line })
        }
      }
      return out
    }
  }
}
</script>

<style lang="scss" scoped>
.legal {
  position: relative;
  background: $beige;
  color: $navy;
  padding: 210px 0 72px;
  min-height: 70vh;
}

// décor livré déjà coupé au bord droit : collé en haut à droite, à sa taille réelle
.legal__stars {
  position: absolute;
  top: 92px; // sous la barre de navigation
  right: 0;
  width: 199px;
  pointer-events: none;
  user-select: none;
}

.legal__inner {
  position: relative;
}

.legal__title {
  margin-bottom: 40px;
}

.legal__updated,
.legal__intro,
.legal__section {
  max-width: 980px;
}

.legal__updated {
  font-size: 14px;
  font-weight: 700;
  font-style: italic;
  margin-bottom: 56px;
}

.legal__intro {
  font-size: 14px;
  line-height: 1.65;
  margin-bottom: 20px;
}

.legal__section {
  margin-top: 26px;

  h2 {
    font-size: 23px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  p,
  li {
    font-size: 14px;
    line-height: 1.65;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li::before {
    content: '- ';
  }
}

.legal__back {
  margin-top: 90px;
  text-align: center;
}

@include tablet-down {
  .legal__stars {
    width: 140px;
  }
}

@include mobile {
  .legal {
    padding: 150px 0 56px;
  }

  // le décor passerait sous le titre sur écran étroit
  .legal__stars {
    display: none;
  }

  .legal__updated {
    margin-bottom: 36px;
  }

  .legal__section h2 {
    font-size: 19px;
  }

  .legal__back {
    margin-top: 56px;
  }
}
</style>
